import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from "reactstrap"
import { Route, Routes } from 'react-router-dom'
import AutomatelyListHeader from "./AutomatelyListHeader"
import AutomationList from "./AutomationList"
import WorkflowBuilder from "./WorkflowBuilder/WorkflowBuilder"
import ExecutionLogsList from "./WorkflowBuilder/ExecutionLogsList"
import ListingTabs from "../Material/ListingTabs"
import { useAdvancedFilters } from '../Filters/filterUrl'
import "./Automately.css"

const AUTOMATION_LISTING_TABS = [
    { id: 'automations', name: 'Automations', iconClassName: 'fa fa-code-fork' },
    { id: 'execution-logs', name: 'Execution Logs', iconClassName: 'fa fa-history' },
]

export default function AutomatelyContainer() {
    return (
        <div className="AutomatelyContainer">
            <Routes>
                <Route path="/new" element={<WorkflowBuilder />} />
                <Route path="/:id" element={<WorkflowBuilder />} />
                <Route path="/" element={<AutomationWorkspace />} />
            </Routes>
        </div>
    )
}

const AutomationWorkspace = () => {
    const [activeTab, setActiveTab] = useState(() => (
        window.location.hash === '#execution-logs' ? 'execution-logs' : 'automations'
    ))
    const [automationSearchTerm, setAutomationSearchTerm] = useState('')
    const [executionLogSearchTerm, setExecutionLogSearchTerm] = useState('')
    const [, setAdvancedFilters] = useAdvancedFilters()
    const activeSearchTerm = activeTab === 'automations' ? automationSearchTerm : executionLogSearchTerm
    const setActiveSearchTerm = activeTab === 'automations' ? setAutomationSearchTerm : setExecutionLogSearchTerm

    useEffect(() => {
        const syncTabWithFragment = () => {
            const requestedTab = window.location.hash.replace('#', '')
            setActiveTab((currentTab) => {
                const nextTab = (requestedTab === 'execution-logs' || requestedTab === 'automations') ? requestedTab : currentTab
                if (window.location.hash !== `#${nextTab}`) {
                    window.history.replaceState(
                        null,
                        '',
                        `${window.location.pathname}${window.location.search}#${nextTab}`
                    )
                }
                return nextTab
            })
        }

        syncTabWithFragment()
        window.addEventListener('hashchange', syncTabWithFragment)
        return () => window.removeEventListener('hashchange', syncTabWithFragment)
    }, [])

    const handleTabChange = (tab) => {
        if (tab !== activeTab) setAdvancedFilters([])
        setActiveTab(tab)
        if (window.location.hash !== `#${tab}`) window.location.hash = tab
    }

    return (
        <Container fluid className="bos-listing-container automately-list-page">
            <ListingTabs
                tabs={AUTOMATION_LISTING_TABS}
                activeTab={activeTab}
                onChange={handleTabChange}
            />
            <AutomatelyListHeader
                activeTab={activeTab}
                searchTerm={activeSearchTerm}
                setSearchTerm={setActiveSearchTerm}
            />
            <Row className="automately-list-row">
                <Col sm="12">
                    {activeTab === 'automations' ? (
                        <AutomationList searchTerm={automationSearchTerm} />
                    ) : (
                        <ExecutionLogsList showAutomation embedded searchTerm={executionLogSearchTerm} />
                    )}
                </Col>
            </Row>
        </Container>
    )
}
